// Supervisory review section form field enum
export enum SupervisoryReviewFormField {
  ID_BADGE = 'supervisory-review/id-badge',
  HONORING_RIGHTS = 'supervisory-review/honoring-rights',
  EMERGENCY_PROTOCOL = 'supervisory-review/emergency-protocol',
  HYGIENE_PRECAUTIONS = 'supervisory-review/hygiene-precautions',
  REPORTING_CHANGES = 'supervisory-review/reporting-changes',
  GRIEVANCE_COMPLAINT = 'supervisory-review/grievance-complaint',
  POC_DOC_REVIEWED_WITH_CAREGIVER = 'supervisory-review/poc-doc-reviewed-with-caregiver',
  PPE_ACCESS = 'supervisory-review/ppe-access',
  SUPERVISION_OBSERVED = 'supervisory-review/supervision-observed',
  COMMENTS = 'supervisory-review/comments',
  TASK_OBSERVED = 'supervisory-review/task-observed',
  PATIENT_STATUS = 'supervisory-review/patient-status',
  EDUCATION_PROVIDED = 'supervisory-review/education-provided',
  CAREGIVER_EDUCATION_TOPIC = 'supervisory-review/caregiver-education-topic'
}
